import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ArchiveLocationEnvironmentInput, UnarchiveLocationEnvironmentInput } from '../../api/location-sectors/location-sectors.type';
import { ARCHIVE_LOCATION_ENVIRONMENT_MUTATION, UNARCHIVE_LOCATION_ENVIRONMENT_MUTATION } from './location-environment.query';

@Injectable({
  providedIn: 'root'
})
export class ArchiveLocationEnvironmentApi {
  public constructor(private readonly apollo: Apollo) {}

  public async archive(params: ArchiveLocationEnvironmentInput): Promise<void> {
    await this.apollo.mutate({
      mutation: ARCHIVE_LOCATION_ENVIRONMENT_MUTATION,
      variables: { input: params },
    }).toPromise();
  }

  public async unarchive(params: UnarchiveLocationEnvironmentInput): Promise<void> {
    await this.apollo.mutate({
      mutation: UNARCHIVE_LOCATION_ENVIRONMENT_MUTATION,
      variables: { input: params },
    }).toPromise();
  }

}
